import { formatPostalCode, type JobLocation } from '@hemmafixa/shared';
import { LocationMap } from '@hemmafixa/ui';
import { fill, useI18n } from '@/i18n/context';
import { env } from '@/lib/env';

/** Where the job is: the pin the client set on the form's map. Nothing for jobs posted without one. */
export function JobLocationMap({
  location,
  postalCode,
  className,
}: {
  location: JobLocation | null;
  postalCode: string;
  className?: string;
}) {
  const { t } = useI18n();
  if (!location) return null;
  const place = formatPostalCode(postalCode);
  return (
    <LocationMap
      center={location}
      apiKey={env.googleMapsApiKey}
      label={fill(t.job.mapLabel, { place })}
      caption={`${t.job.location} · ${place}`}
      className={className}
    />
  );
}
